/**
 * @fileOverview Cross
 */
export var Cell = function Cell(props) {
  return null;
};
Cell.displayName = 'Cell';